import { Box, CircularProgress, LinearProgress, Skeleton, Stack } from '@mui/material';
import PropTypes from 'prop-types';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';

export function LoadingList() {
  return (
    <Stack spacing={1}>
      <Skeleton variant="rectangular" height={64} />
      <Skeleton variant="rectangular" height={64} />
      <Skeleton variant="rectangular" height={64} />
      <Skeleton variant="rectangular" height={64} />
      <Skeleton variant="rectangular" height={64} />
      <Skeleton variant="rectangular" height={64} />
      <Skeleton variant="rectangular" height={64} />
      <Skeleton variant="rectangular" height={64} />
      <Skeleton variant="rectangular" height={64} />
      <Skeleton variant="rectangular" height={64} />
    </Stack>
  );
}

export function LoadingSpinner({ setIsLoading }) {
  const { i18n } = useTranslation();

  useEffect(() => {
    let onInit = null;

    if (i18n.isInitialized) {
      setIsLoading(false);
    } else {
      onInit = () => setIsLoading(false);
      i18n.on('initialized', onInit);
    }

    return () => {
      if (onInit) {
        i18n.off('initialized', onInit);
      }
    };
  }, [i18n.isInitialized]);

  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        width: '100%',
        height: 'calc(100vh - 128px)',
        fontFamily: 'Rubik Doodle Shadow',
      }}
    >
      <CircularProgress />
    </Box>
  );
}

LoadingSpinner.propTypes = {
  setIsLoading: PropTypes.func.isRequired,
};

export function LoadingScreen() {
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        width: '100vw',
        height: '100vh',
        bgcolor: '#0f172a',
      }}
    >
      {/* Logo Image */}
      <Box
        component="img"
        src="/splashscreens/splash-512x512.png"
        alt="Logo"
        sx={{
          width: { xs: '80vh', md: '60vh' }, // Adjust size as needed
          height: 'auto',
          objectFit: 'contain',
        }}
      />

      {/* Loading Indicator */}
      <CircularProgress color="primary" size={80} />
    </Box>
  );
}

export function LoadingBar() {
  return <LinearProgress />;
}
